import {HANDLE_DARK_PREFERENCE, LOAD_PREFERENCES} from "./types";

const permitFields = ['_dark', '_author'];

export const loadPreferences = (preferences) => {
	if (typeof preferences === 'object') {

		for (let preference in preferences) {
			if (!permitFields.includes(preference)) {
				delete preferences[preference];
			}
		}

		return {
			type: LOAD_PREFERENCES,
			payload: preferences
		};
	}
};

export const toggleDarkMode = (value) => dispatch => {
	return dispatch({
		type: HANDLE_DARK_PREFERENCE,
		payload: value
	});
};